import { configSettings } from '@/lib/config';
import Cookies from 'js-cookie';
import { GOOGLE_AD_CONVERSION_ID, GOOGLE_GA4_MEASUREMENT_ID } from '@/lib/constants';

// TODO: Add these back in when implemented
// import * as amplitude from '@amplitude/analytics-browser';
// import store from '~/store';
// import { getFlags } from '~/plugins/feature-flags.js';
// import { getSessionUUID, getCookieUUID } from '../store/modules/Global';

const apiUrl = configSettings.analyticsApi;

interface StanAnalyticsOptions {
    meta?: Record<string, any>;
    props?: Record<string, any>;
    callback?: () => void;
}

function trigger(eventName: string, options: StanAnalyticsOptions) {
    // Quick little check to see if the apiUrl is set
    if (!apiUrl) {
        return;
    }

    // TODO: Check for admin logged in as user
    // const isAdminLoggedInAsUser = store.getters['Auth/isAdminLoggedInAsUser'];
    // if (isAdminLoggedInAsUser) return;
    const payload: Record<string, any> = {};
    payload.n = eventName;
    payload.u = window.location.href;
    payload.r = window.document.referrer || '';
    payload.w = window.innerWidth;
    if (options && options.meta) {
        payload.m = options.meta;
    }
    if (!('m' in payload)) {
        payload.m = {};
    }
    payload.m.platform = {
        // Ideally we dont do this "as any" but we need to handle the case where the properties are not present on Navigator
        oscpu: (navigator as any).oscpu || '',
        vendor: navigator.vendor || '',
        platform: navigator.platform || '',
        cpuClass: (navigator as any).cpuClass || '',
        appName: navigator.appName || '',
        appVersion: navigator.appVersion || '',
        codeName: navigator.appCodeName || '',
        userAgent: navigator.userAgent || '',
    };

    if (options && options.props) {
        payload.p = options.props;
    }
    const request = new XMLHttpRequest();

    request.open('POST', apiUrl, true);
    request.setRequestHeader('Content-Type', 'application/json');
    request.send(JSON.stringify(payload));

    // TODO: Amplitude Analytics
    //   amplitude.track(eventName, payload);

    // Google Analytics (gtag)
    if (window.gtag) {
        const flattenOptions = { ...payload.m, ...payload.p };

        // Replace hyphens with underscores in keys (GA requirement)
        Object.keys(flattenOptions).forEach(v => {
            if (v.includes('-')) {
                flattenOptions[v.replace(/-/g, '_')] = flattenOptions[v];
                delete flattenOptions[v];
            }
        });

        // Send to GA4 and Ad Conversion
        flattenOptions.send_to = [GOOGLE_GA4_MEASUREMENT_ID, GOOGLE_AD_CONVERSION_ID];

        window.gtag('event', eventName, flattenOptions);
    }

    request.onreadystatechange = () => {
        if (request.readyState === 4) {
            if (options && options.callback) {
                options.callback();
            }
        }
    };

    // Microsoft Clarity - set event tag
    if (window.clarity) {
        window.clarity('set', eventName, '1');
    }
}

export async function stanAnalytics(name: string, opts: StanAnalyticsOptions = {}) {
    const meta = opts.meta || {};
    const props = opts.props || {};
    // TODO: Get IP address when store is implemented
    //   // Plugin default metadata
    //   meta.ip = store.getters['Global/getIPAddress'];

    // TODO: Get session and cookie UUIDs
    //   meta.sessionUUID = getSessionUUID();
    //   meta.cookieUUID = getCookieUUID();

    // TODO: Get experiments
    // props.experiments = getFlags();
    const utmSource = Cookies.get('utm_source');
    const utmMedium = Cookies.get('utm_medium');
    const utmCampaign = Cookies.get('utm_campaign');

    if (utmSource) {
        props.utmSource = utmSource;
    }
    if (utmMedium) {
        props.utmMedium = utmMedium;
    }
    if (utmCampaign) {
        props.utmCampaign = utmCampaign;
    }

    // Disabled Fingerprint until figure out the payment and plan details
    // meta.visitorId = await getVisitorID()
    return trigger(name, { meta, props });
}
